import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

const RedirectToAssessment = () => {
  const { workspaceId, userGroupId, assessmentId } = useParams();

  return (
    <Redirect
      to={`/w/${workspaceId}/pm/user-groups${userGroupId}/assessments/${assessmentId}`}
    />
  );
};

export default RedirectToAssessment;
